/* The Hive Hatchery — global script (v2).
   Lives in assets/egg-builder.js, loaded from layout/theme.liquid, because Lumia
   injects sections after page load and inline <script> tags inside injected HTML
   never execute. Handles two sections:
     .eb-root — the dragon egg builder (hatchling crystals, fixed slots)
     .cs-root — the crystal showcase ("Meet the hatchlings") */
(function () {
  if (window.__eggBuilderLoaded) return;
  window.__eggBuilderLoaded = true;

  /* ---------- shared helpers ---------- */

  function shades(hex) {
    var n = parseInt(hex.slice(1), 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    function h(r, g, b) {
      return '#' + [r, g, b].map(function (x) {
        x = Math.max(0, Math.min(255, Math.round(x)));
        var s = x.toString(16);
        return s.length < 2 ? '0' + s : s;
      }).join('');
    }
    return {
      base: hex,
      dark: h(r * 0.58, g * 0.58, b * 0.58),
      light: h(r + (255 - r) * 0.5, g + (255 - g) * 0.5, b + (255 - b) * 0.5)
    };
  }

  /* Hatchling crystal: faceted gem cluster, drawn in a 0 0 190 120 local space,
     ground line at y=108. shimClass animates the light facets. */
  function crystalSVG(hex, shimClass) {
    var c = shades(hex);
    var s = shimClass || '';
    return '<polygon points="88,108 78,44 96,18 110,46 106,108" fill="' + c.base + '"/>' +
      '<polygon points="96,18 110,46 106,108 98,108 96,52" fill="' + c.dark + '"/>' +
      '<polygon class="' + s + '" points="78,44 96,18 96,52 86,60" fill="' + c.light + '"/>' +
      '<polygon points="62,108 54,68 68,50 78,72 76,108" fill="' + c.base + '"/>' +
      '<polygon points="68,50 78,72 76,108 70,108" fill="' + c.dark + '"/>' +
      '<polygon points="112,108 108,76 122,60 132,80 128,108" fill="' + c.base + '"/>' +
      '<polygon class="' + s + '" points="108,76 122,60 120,84 114,108 112,108" fill="' + c.light + '"/>' +
      '<polygon class="' + s + '" points="142,104 150,92 152,106" fill="' + c.light + '"/>' +
      '<polygon points="40,106 46,96 50,108" fill="' + c.dark + '"/>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  /* ---------- egg builder (.eb-root) ---------- */

  function ebCfg(root) {
    if (root.__ebCfg) return root.__ebCfg;
    var el = root.querySelector('[data-eb-config]');
    if (!el) return null;
    try { root.__ebCfg = JSON.parse(el.textContent); }
    catch (e) { if (window.console) console.error('Egg builder: config could not be read', e); }
    return root.__ebCfg;
  }

  /* Fixed-position slots: array of colour objects or null, one entry per slot.
     Removing a pick leaves a gap at that slot until a new colour fills it. */
  function ebPicks(root, max) {
    if (!root.__ebPicks || root.__ebPicks.length !== max) {
      root.__ebPicks = [];
      for (var i = 0; i < max; i++) root.__ebPicks.push(null);
    }
    return root.__ebPicks;
  }

  function ebRender(root, popIndex) {
    var c = ebCfg(root);
    if (!c) return;
    var picks = ebPicks(root, c.maxPicks);
    var count = 0;
    for (var i = 0; i < picks.length; i++) if (picks[i]) count++;
    var v = c.variants[count];

    var bannerText = root.querySelector('[data-eb-banner-text]');
    var banner = root.querySelector('[data-eb-banner]');
    if (bannerText) bannerText.textContent = c.banners[Math.min(count, c.banners.length - 1)];
    if (banner) {
      if (count >= c.maxPicks) banner.classList.add('eb-full');
      else banner.classList.remove('eb-full');
    }

    var slots = root.querySelector('[data-eb-slots]');
    if (slots) {
      var slotsHtml = '';
      for (var j = 0; j < c.maxPicks; j++) {
        if (picks[j]) {
          var pop = (j === popIndex) ? ' eb-pop' : '';
          slotsHtml += '<div class="eb-slot">' +
            '<span class="eb-crystal' + pop + '"><svg viewBox="30 8 130 108" width="46" height="38" aria-hidden="true">' + crystalSVG(picks[j].hex, 'eb-shim-' + j) + '</svg></span>' +
            '<span class="eb-slot-text">' + c.slotWord + ' ' + (j + 1) + ' &middot; ' + escapeHtml(picks[j].label) + '</span>' +
            '<button type="button" class="eb-remove" data-eb-remove="' + j + '" aria-label="Remove ' + c.slotWord.toLowerCase() + ' ' + (j + 1) + '">&times;</button>' +
            '</div>';
        } else {
          slotsHtml += '<div class="eb-slot">' +
            '<span class="eb-chip eb-empty"></span>' +
            '<span class="eb-slot-text eb-dim">' + escapeHtml(c.emptySlotText) + '</span>' +
            '</div>';
        }
      }
      slots.innerHTML = slotsHtml;
    }

    var tiers = root.querySelectorAll('[data-eb-tier]');
    Array.prototype.forEach.call(tiers, function (t) {
      if (Number(t.getAttribute('data-count')) === count) t.classList.add('eb-active');
      else t.classList.remove('eb-active');
    });

    var props = root.querySelector('[data-eb-props]');
    if (props) {
      var propsHtml = '';
      var num = 0;
      for (var k = 0; k < picks.length; k++) {
        if (!picks[k]) continue;
        num++;
        var val = picks[k].surprise ? c.surpriseValue : picks[k].label;
        propsHtml += '<input type="hidden" name="properties[' + escapeHtml(c.propertyName) + ' ' + num + ']" value="' + escapeHtml(val) + '">';
      }
      props.innerHTML = propsHtml;
    }

    var variantId = root.querySelector('[data-eb-variant-id]');
    var buy = root.querySelector('[data-eb-buy]');
    if (buy) {
      if (v && variantId) variantId.value = v.id;
      if (v && v.available) {
        buy.disabled = false;
        buy.textContent = c.buttonText + ' \u2014 ' + v.price;
      } else {
        buy.disabled = true;
        buy.textContent = c.soldOutText;
      }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-eb-swatch]'), function (s) {
      s.disabled = count >= c.maxPicks;
    });
  }

  /* ---------- crystal showcase (.cs-root) ---------- */

  function csCfg(root) {
    if (root.__csCfg) return root.__csCfg;
    var el = root.querySelector('[data-cs-config]');
    if (!el) return null;
    try { root.__csCfg = JSON.parse(el.textContent); }
    catch (e) { if (window.console) console.error('Crystal showcase: config could not be read', e); }
    return root.__csCfg;
  }

  function csRender(root, idx) {
    var c = csCfg(root);
    if (!c || !c.colours.length) return;
    if (idx < 0 || idx >= c.colours.length) idx = 0;
    var col = c.colours[idx];

    Array.prototype.forEach.call(root.querySelectorAll('[data-cs-img]'), function (img) {
      img.style.display = (Number(img.getAttribute('data-cs-img')) === idx && col.img) ? '' : 'none';
    });

    var svgWrap = root.querySelector('[data-cs-svg]');
    if (svgWrap) {
      if (col.img) {
        svgWrap.style.display = 'none';
      } else {
        svgWrap.style.display = '';
        svgWrap.innerHTML = '<svg viewBox="30 8 130 108" width="100%" style="max-width:180px;">' + crystalSVG(col.hex, 'cs-shim') + '</svg>';
      }
    }

    var nameEl = root.querySelector('[data-cs-name]');
    if (nameEl) nameEl.textContent = col.label;

    Array.prototype.forEach.call(root.querySelectorAll('[data-cs-sw]'), function (b) {
      if (Number(b.getAttribute('data-cs-sw')) === idx) b.classList.add('cs-on');
      else b.classList.remove('cs-on');
    });
  }

  /* ---------- init + events ---------- */

  function initAll() {
    var ebs = document.querySelectorAll('.eb-root');
    for (var i = 0; i < ebs.length; i++) {
      if (!ebs[i].__ebDone) { ebs[i].__ebDone = true; ebRender(ebs[i], -1); }
    }
    var css = document.querySelectorAll('.cs-root');
    for (var j = 0; j < css.length; j++) {
      if (!css[j].__csDone) { css[j].__csDone = true; csRender(css[j], 0); }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var sw = t.closest('.eb-root [data-eb-swatch]');
    if (sw && !sw.disabled) {
      var root = sw.closest('.eb-root');
      var c = ebCfg(root);
      if (!c) return;
      var picks = ebPicks(root, c.maxPicks);
      for (var i = 0; i < picks.length; i++) {
        if (!picks[i]) {
          picks[i] = c.colours[Number(sw.getAttribute('data-index'))];
          ebRender(root, i);
          break;
        }
      }
      return;
    }

    var rm = t.closest('.eb-root [data-eb-remove]');
    if (rm) {
      e.preventDefault();
      var root2 = rm.closest('.eb-root');
      var c2 = ebCfg(root2);
      if (!c2) return;
      ebPicks(root2, c2.maxPicks)[Number(rm.getAttribute('data-eb-remove'))] = null;
      ebRender(root2, -1);
      return;
    }

    var cs = t.closest('.cs-root [data-cs-sw]');
    if (cs) {
      csRender(cs.closest('.cs-root'), Number(cs.getAttribute('data-cs-sw')));
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);

  function watch() {
    if (!document.body) return;
    new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
